export default "__VITE_ASSET__Eq4Ci$yE__"